/**
 * Dealer Network AdminService API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { AnnouncementDto } from '../model/announcementDto';
import { AnnouncementListItemDto } from '../model/announcementListItemDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AnnouncementViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * AmsAction:GET/api/AnnouncementView/activeAnnouncement AmsResource:{country}/{business}/_* 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getActiveAnnouncement(observe?: 'body', reportProgress?: boolean): Observable<AnnouncementDto>;
    public getActiveAnnouncement(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AnnouncementDto>>;
    public getActiveAnnouncement(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AnnouncementDto>>;
    public getActiveAnnouncement(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AnnouncementDto>(`${this.basePath}/api/AnnouncementView/activeAnnouncement`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/AnnouncementView/admin/{announcementId} AmsResource:{country}/_* 
     * @param announcementId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAdminAnnouncement(announcementId: string, observe?: 'body', reportProgress?: boolean): Observable<AnnouncementDto>;
    public getAdminAnnouncement(announcementId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AnnouncementDto>>;
    public getAdminAnnouncement(announcementId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AnnouncementDto>>;
    public getAdminAnnouncement(announcementId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (announcementId === null || announcementId === undefined) {
            throw new Error('Required parameter announcementId was null or undefined when calling getAdminAnnouncement.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AnnouncementDto>(`${this.basePath}/api/AnnouncementView/admin/${encodeURIComponent(String(announcementId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/AnnouncementView/admin/{countryId}/list AmsResource:{country}/_* 
     * @param countryId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAdminAnnouncementList(countryId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AnnouncementListItemDto>>;
    public getAdminAnnouncementList(countryId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AnnouncementListItemDto>>>;
    public getAdminAnnouncementList(countryId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AnnouncementListItemDto>>>;
    public getAdminAnnouncementList(countryId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling getAdminAnnouncementList.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AnnouncementListItemDto>>(`${this.basePath}/api/AnnouncementView/admin/${encodeURIComponent(String(countryId))}/list`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
